import React, { useState } from 'react';
import { Video } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { VideoRecorder } from './VideoRecorder';
import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';

interface VideoButtonProps {
  onVideoCapture: (file: File) => Promise<void>;
  disabled?: boolean;
}

export const VideoButton: React.FC<VideoButtonProps> = ({
  onVideoCapture,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleVideoCapture = async (file: File) => {
    await onVideoCapture(file);
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button
          size="sm"
          disabled={disabled}
          className="bg-orange-500 hover:bg-orange-600 text-white border-0 text-xs"
        >
          <Video className="h-4 w-4 mr-1" />
          Record Video
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-md">
        <VideoRecorder onVideoCapture={handleVideoCapture} disabled={disabled} />
      </DialogContent>
    </Dialog>
  );
};